import { apiService } from './apiService';

export type GstFilingInvoiceRow = {
  sale_date: string;
  tax_invoice_number?: string | null;
  transaction_number: string;
  total_amount: number;
  taxable_amount: number;
  exempt_amount: number;
  zero_rated_amount: number;
  output_gst: number;
  buyer_name?: string | null;
  buyer_cid?: string | null;
  buyer_tpn?: string | null;
  buyer_address?: string | null;
  buyer_required: boolean;
  buyer_complete: boolean;
};

export type GstFilingPurchaseRow = {
  received_date: string;
  grpo_number: string;
  supplier_invoice?: string | null;
  vendor_name?: string | null;
  taxable_amount: number;
  exempt_amount: number;
  zero_rated_amount: number;
  input_gst: number;
  gross: number;
};

export type GstFilingSummary = {
  start_date: string;
  end_date: string;
  gst_registered: boolean;
  gst_prices_inclusive: boolean;
  standard_rate?: number;
  supplier_tpn?: string | null;
  tax_invoice_count: number;
  output_gst: number;
  taxable_amount: number;
  exempt_amount: number;
  zero_rated_amount: number;
  input_gst: number;
  input_taxable_amount: number;
  input_exempt_amount: number;
  input_zero_rated_amount: number;
  net_gst: number;
  invoices_missing_buyer: number;
  buyer_threshold: number;
};

export type GstFilingPack = {
  summary: GstFilingSummary;
  tax_invoices: GstFilingInvoiceRow[];
  purchases: GstFilingPurchaseRow[];
};

export async function getGstFilingPack(startDate: string, endDate: string): Promise<GstFilingPack> {
  return apiService.get<GstFilingPack>('/reports/gst-filing', {
    start_date: startDate,
    end_date: endDate,
  });
}
